import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { getColor, StyleVars } from 'core/utils/Styles';
import typeScale from 'core/utils/typeScale';
import { truncateToNearestWord } from 'core/utils/stringUtils';

const DESCRIPTION_TRUNCATE_LENGTH = 80;

const VariantDescription = styled.div`
	display: block;
	clear: both;

	color: ${getColor('gray9')};
	font-size: ${typeScale(1.75)};
	transition: 0.3s ease-in-out;
	font-weight: 400;
	margin: ${StyleVars.defaultSpacingUnit / 2}px 0px;
`;

const ShowMoreSpan = styled.span`
	cursor: pointer;
	color: ${getColor('primaryBrand')};
`;

const ShowMoreComponent = (props) => {
	return (
		<ShowMoreSpan onClick={props.onClick}>
			{props.showMore ? '... Show More' : ' Show Less'}
		</ShowMoreSpan>
	);
};


/**
 * VariantDescriptionComponent displays given description to use under variant selection.
 * TODO: Consolidate this truncation methods with core/component/TruncatedContnet.
 * 		This component uses truncateToNearestWord which is prefered, but TruncatedContnet
 * 		should be updated use this.
 * @param {{
 * 	description: string
 * }} props
 * @returns
 */
export const VariantDescriptionComponent = (props) => {
	const [showFullDesc, setShowFullDesc] = useState(false);

	useEffect(() => {
		setShowFullDesc(false);
	}, [props.description]);

	let renderedDescription = props.description;
	if (!showFullDesc) {
		renderedDescription = truncateToNearestWord(props.description, DESCRIPTION_TRUNCATE_LENGTH);
	}

	const handleShowClick = () => {
		setShowFullDesc(!showFullDesc);
	};

	return props.description && (
		<VariantDescription>
			{renderedDescription}{props.description.length > DESCRIPTION_TRUNCATE_LENGTH && (
				<ShowMoreComponent showMore={!showFullDesc} onClick={handleShowClick} />
			)}
		</VariantDescription>
	);
};
